<?php

\Core\View::$template = function () {
    $html = '
        <div class="nav_wrap">
      <nav class="navbar navbar-expand-lg fixed-top nav-transparent">
      <div class="container">
        <a class="navbar-brand" href="/" style="height: 90px;">
          <img src="' . IMAGE_ASSET_PREFIX . 'app/Default/Assets/images/logg.png" height="80">
        </a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"><i class="fa fa-bars"></i></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarResponsive">
          <ul class="navbar-nav ml-auto">
            <li class="nav-item active">
              <a class="nav-link" href="#">
                Invite
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link go-register-hiring" href="/register/hiring">Looking?</a>
            </li>
            <!--<li class="nav-item">
              <a class="nav-link go-register-hiring" href="/register/hiring">Hiring?</a>
            </li>
            <li class="nav-item">
              <a class="nav-link nav-signup go-jobslist" href="/jobslist">Jobs</a>
            </li>-->
            <li class="nav-item">
              <a class="nav-link nav-signup" id="go-index-page" href="/login" >Login</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    </div>
      <div class="container"><div class="row"><div class="col-sm-6 offset-sm-3 col-12">  
        <form id="pharaoh_form" class="center-block register-cstm clearfix rgsttr_form">
            <div class="col-sm-12 col-12">               
                    <h2 class="register-header"><span>Employer Registration</span></h2>
                </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <label>Username</label>
                  <input type="text" name="username" id="username" class="form-control"/> 
                </div> 
              </div> 
            </div>
            
            <div class="row clearfix ">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>First Name</label>
                        <input type="text" name="first_name" id="first_name"  class="form-control"/> 
                    </div> 
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Last Name</label>
                        <input type="text" name="last_name" id="last_name"  class="form-control"/> 
                    </div>                
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Email</label>
                        <input type="text" name="email" id="email" class="form-control" />
                    </div> 
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Company Name</label>
                        <input type="text" name="company_name" id="company_name"  class="form-control"/> 
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Password</label>
                        <input type="password" name="pass" id="pass" class="form-control" />
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Password Confirmation</label>
                        <input type="password" name="pass_conf" id="pass_conf" class="form-control" />
                    </div> 
                   
                </div> 
            </div>
            <hr> ';

    $html = $html . '    <div class="col-sm-12 text-center">';
    $html = $html . '    <div class="btn btn-success">';
    $html = $html . '        <span id="perform-hiring-interest-reg-attempt">Register</span>';
    $html = $html . '    </div>';
    $html = $html . '    <div class="btn btn-warning">';
    $html = $html . '        <span id="cancel-registration" >Cancel</span>';
    $html = $html . '    </div>';
    $html = $html . '</div>';
    $html = $html . '</form> </div></div></div>';


    $html = $html .'
        <section class="footer-bottom">
      <div class="container">
        <div class="row clearfix">
          <div class="col-md-3 col-12 col-xs-12 col-lg-3 copyright_footer">
            © 2023 Video Interviews
          </div>' ;

    if (CURRENT_TARGET !== 'mobile') {
        $html = $html .'
          <div class="col-md-9 col-12 col-xs-12 col-lg-9">
            <ul class="footer-links">
              <li>
                <a href="#">Hire Quality</a>
              </li>
              <li>
                <a class="go-jobslist" href="/jobslist">Jobs</a>
              </li>
              <li>
                <a href="#">Careers</a>
              </li>
              <li>
                <a href="#">Privacy</a>
              </li>
              <li>
                <a href="#">Terms</a>
              </li>
              <li>
                <a href="#">Contact</a>
              </li>
              <li>
                <a href="#">Twitter</a>
              </li>
            </ul>
          </div> ';
    }

    $html = $html .'
        </div>
      </div>
    </section>
    ';

    return $html ;

};


// WEBPACK FOOTER //
// app/Register/View/RegisterHiring.php